import { Fragment } from 'react';
import PropTypes from 'prop-types';

import SeoSnippetShape from '../../shapes/SeoSnippet';

import './SEOSnippetSeo.scss';

const SEOSnippetSeo = ({ seoSnippet }) => {
  if (!seoSnippet?.features) {
    return null;
  }

  return (
    <article className="seo-snippet-variant">
      <h2>{seoSnippet.title}</h2>
      <section className="seo-snippet-table">
        {seoSnippet.features.map(feature => {
          return (
            <Fragment key={feature.title}>
              <div className="seo-snippet-table--row">
                <strong>{feature.title}</strong>
              </div>
              <div className="seo-snippet-table--row">{feature.content}</div>
            </Fragment>
          );
        })}
      </section>
    </article>
  );
};

SEOSnippetSeo.propTypes = {
  seoSnippet: PropTypes.shape(SeoSnippetShape).isRequired
};

export default SEOSnippetSeo;
